<template>
    <div class="student-page">
        <!-- 查询筛选卡片 -->
        <el-card shadow="always" class="filter-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <i class="el-icon-user-solid"></i>
                    <span>学生管理</span>
                    <el-divider direction="vertical"></el-divider>
                    <span class="header-sub">筛选条件</span>
                </div>
            </div>
            <el-form :inline="true" :model="query" class="filter-form">
                <el-form-item label="年级">
                    <el-select clearable v-model="query.gradeId" placeholder="全部年级" style="width: 150px" @change="onFilterGradeChange">
                        <el-option v-for="item in gradeList" :key="item.id" :label="item.gradeName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="班级">
                    <el-select clearable v-model="query.classId" placeholder="请先选择年级" style="width: 150px" :disabled="!query.gradeId">
                        <el-option v-for="item in filteredQueryClassList" :key="item.id" :label="item.className" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="学生姓名">
                    <el-input clearable v-model="query.nickname" placeholder="请输入学生姓名" style="width: 140px"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input clearable v-model="query.phone" placeholder="请输入手机号" style="width: 140px"></el-input>
                </el-form-item>
                <el-form-item label="登录名">
                    <el-input clearable v-model="query.username" placeholder="请输入登录名" style="width: 140px"></el-input>
                </el-form-item>
                <el-form-item label="学号">
                    <el-input clearable v-model="query.studentNo" placeholder="请输入学号" style="width: 120px"></el-input>
                </el-form-item>
                <el-form-item label="家长绑定">
                    <el-select clearable v-model="query.hasParent" placeholder="全部" style="width: 120px">
                        <el-option label="已绑定" :value="1"></el-option>
                        <el-option label="未绑定" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 表格卡片 -->
        <el-card shadow="always" class="table-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <span>数据列表</span>
                    <span class="total-badge">共 <b>{{ total }}</b> 条</span>
                </div>
                <div class="card-header-right">
                    <el-button type="success" icon="el-icon-upload2" @click="importVisible = true">批量导入</el-button>
                    <el-button type="primary" icon="el-icon-plus" @click="btnInsert(null)">新增学生</el-button>
                </div>
            </div>
            <el-table
                :data="list"
                border
                stripe
                v-loading="tableLoading"
                element-loading-text="加载中..."
                style="width: 100%">
                <el-table-column type="index" label="序号" width="80" align="center"/>
                <el-table-column prop="gradeName" label="年级" width="80" show-overflow-tooltip/>
                <el-table-column prop="className" label="班级" width="80" show-overflow-tooltip/>
                <el-table-column prop="studentNo" label="学号" width="90" align="center"/>
                <el-table-column prop="nickname" label="学生姓名" show-overflow-tooltip/>
                <el-table-column prop="phone" label="手机号" show-overflow-tooltip/>
                <el-table-column prop="username" label="登录名" show-overflow-tooltip/>
                <el-table-column prop="createTime" label="创建时间" align="center"/>
                <el-table-column label="学员类型" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.type === 2 ? 'success' : 'info'" size="small" effect="plain">
                            {{ scope.row.type === 2 ? '正式学员' : '试用学员' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="count" label="剩余试卷" width="90" align="center"/>
                <el-table-column label="家长" width="80" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-user" @click="showParentDrawer(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="剩余课时" width="100" align="center">
                    <template slot-scope="scope">
                        <span class="class-hours-link" @click="showClassHoursDrawer(scope.row)">
                            {{ scope.row.classHours }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="280" fixed="right">
                    <template slot-scope="scope">
                        <div class="action-dropdown-group">
                            <el-dropdown trigger="click" size="small"
                                         @command="handleOperateCommand"
                                         @visible-change="(v) => v && (currentOperateRow = scope.row)">
                                <el-button size="mini" type="primary" plain>
                                    编辑<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="edit" icon="el-icon-edit">修改信息</el-dropdown-item>
                                    <el-dropdown-item command="changeType" icon="el-icon-s-flag">变更类型</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <el-dropdown trigger="click" size="small"
                                         @command="handleOperateCommand"
                                         @visible-change="(v) => v && (currentOperateRow = scope.row)">
                                <el-button size="mini" type="success" plain>
                                    资源<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="rechargePaper" icon="el-icon-document-add">充值试卷</el-dropdown-item>
                                    <el-dropdown-item command="rechargeClassHours" icon="el-icon-time">充值课时</el-dropdown-item>
                                    <el-dropdown-item command="setProgress" icon="el-icon-setting" divided>设置进度</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <el-dropdown trigger="click" size="small"
                                         @command="handleOperateCommand"
                                         @visible-change="(v) => v && (currentOperateRow = scope.row)">
                                <el-button size="mini" type="danger" plain>
                                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="delete" icon="el-icon-delete" class="danger-dropdown-item">删除学生</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrapper" v-if="total > 0">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="query.currentPage"
                    :page-size="query.pageSize"
                    :total="total">
                </el-pagination>
            </div>
        </el-card>

        <!-- 新增/编辑对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            width="600px"
            top="8vh"
            :show-close="false"
            @close="closeDialog"
            custom-class="student-dialog">
            <div slot="title" class="batch-header">
                <div class="batch-header-left">
                    <div class="batch-header-icon"><i class="el-icon-user-solid"></i></div>
                    <div>
                        <div class="batch-header-title">{{ dialogTitle }}</div>
                        <div class="batch-header-desc">填写学生基础信息，带 * 为必填项</div>
                    </div>
                </div>
                <i class="el-icon-close batch-header-close" @click="dialogVisible = false"></i>
            </div>
            <el-form :model="formData" ref="formData" :rules="rules" label-width="80px">
                <el-form-item label="所属年级" prop="gradeId">
                    <el-select v-model="formData.gradeId" placeholder="请选择年级" style="width: 100%" clearable @change="onGradeChange">
                        <el-option v-for="item in gradeList" :key="item.id" :label="item.gradeName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属班级" prop="classId">
                    <el-select v-model="formData.classId" placeholder="请先选择年级" style="width: 100%" clearable :disabled="!formData.gradeId">
                        <el-option v-for="item in filteredClassList" :key="item.id" :label="item.className" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="学号" prop="studentNo">
                    <el-input v-model="formData.studentNo" maxlength="20" placeholder="请输入学号"></el-input>
                </el-form-item>
                <el-form-item label="学生姓名" prop="nickname">
                    <el-input v-model="formData.nickname" maxlength="10" placeholder="请输入学生姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="formData.phone" maxlength="11" @blur="handlePhoneBlur" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="登录账号" prop="username">
                    <el-input v-model="formData.username" maxlength="11" disabled placeholder="默认与手机号相同"></el-input>
                </el-form-item>
                <el-form-item label="入学日期" prop="enrollmentDate">
                    <el-date-picker v-model="formData.enrollmentDate" type="date" placeholder="选择日期" style="width: 100%"
                                    value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item label="初始课时" prop="classHours">
                    <el-input-number v-model="formData.classHours" :min="0" :max="9999" style="width: 100%"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitLoading">确定</el-button>
            </div>
        </el-dialog>

        <!-- 批量导入对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="importVisible"
            width="560px"
            top="8vh"
            :show-close="false"
            @close="closeImportDialog"
            custom-class="import-student-dialog">
            <div slot="title" class="batch-header">
                <div class="batch-header-left">
                    <div class="batch-header-icon"><i class="el-icon-upload2"></i></div>
                    <div>
                        <div class="batch-header-title">批量导入学生</div>
                        <div class="batch-header-desc">下载模板填写后上传，支持 Excel(.xlsx)</div>
                    </div>
                </div>
                <i class="el-icon-close batch-header-close" @click="importVisible = false"></i>
            </div>

            <div class="import-body">
                <el-alert type="info" :closable="false" show-icon class="import-tip">
                    <template slot="title">
                        请按模板填写：年级名称、班级名称、学号、学生姓名、手机号、入学日期、初始课时。系统将按"年级+班级"自动匹配班级并创建学生账号。
                    </template>
                </el-alert>
                <div class="import-actions">
                    <el-button icon="el-icon-download" @click="downloadTemplate">下载导入模板</el-button>
                    <el-upload
                        class="import-upload"
                        :show-file-list="true"
                        :auto-upload="false"
                        :disabled="importLoading"
                        :limit="1"
                        accept=".xlsx,.xls"
                        ref="uploadRef"
                        :on-change="handleFileChange"
                        action="#">
                        <el-button type="primary" icon="el-icon-upload2">选择 Excel 文件</el-button>
                    </el-upload>
                </div>
                <div class="import-file" v-if="importFile">
                    已选择：<b>{{ importFile.name }}</b>
                </div>
                <div class="import-result" v-if="importResult">
                    <el-divider></el-divider>
                    <p>导入完成：成功 <b class="ok">{{ importResult.success }}</b> 条，失败 <b class="fail">{{ importResult.fail }}</b> 条（共 {{ importResult.total }} 条）</p>
                    <div class="import-fail-list" v-if="importResult.failList && importResult.failList.length">
                        <div class="fail-title">失败明细：</div>
                        <div class="fail-item" v-for="(f, i) in importResult.failList" :key="i">{{ f }}</div>
                    </div>
                </div>
            </div>

            <div slot="footer">
                <el-button @click="importVisible = false">关闭</el-button>
                <el-button type="primary" icon="el-icon-check" :loading="importLoading" :disabled="!importFile" @click="submitImport">开始导入</el-button>
            </div>
        </el-dialog>

        <!-- 学员类型变更对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            title="学员类型变更"
            :visible.sync="typeDialogVisible"
            width="500px"
            class="student-dialog">
            <el-form :model="typeForm" ref="typeForm" :rules="typeRules" label-width="80px">
                <el-form-item label="学生姓名">
                    <el-input :value="currentStudent.nickname" disabled></el-input>
                </el-form-item>
                <el-form-item label="当前类型">
                    <el-tag :type="currentStudent.type === 2 ? 'success' : 'info'" size="medium" effect="plain">
                        {{ currentStudent.type === 2 ? '正式学员' : '试用学员' }}
                    </el-tag>
                </el-form-item>
                <el-form-item label="变更类型" prop="type">
                    <el-radio-group v-model="typeForm.type">
                        <el-radio :label="1">试用学员</el-radio>
                        <el-radio :label="2">正式学员</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="typeDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitTypeChange" :loading="submitLoading">确认变更</el-button>
            </div>
        </el-dialog>

        <!-- 设置学习进度对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            title="设置学习进度"
            :visible.sync="progressDialogVisible"
            width="700px"
            class="student-dialog">
            <div v-if="progressLoading" style="text-align:center;padding:40px;">
                <i class="el-icon-loading" style="font-size:24px;"></i>
                <p>加载单词数据中...</p>
            </div>
            <template v-else>
                <div style="margin-bottom:16px;">
                    <span style="font-weight:bold;margin-right:16px;">学生：{{ progressStudent.nickname }}</span>
                    <span style="font-weight:bold;margin-right:16px;">年级：{{ progressStudent.gradeName }}</span>
                    <el-radio-group v-model="progressVolume" @change="onVolumeChange" size="small">
                        <el-radio-button v-for="vol in progressVolumeList" :key="vol" :label="vol">{{ vol }}</el-radio-button>
                    </el-radio-group>
                    <el-tag v-if="showCascadeWarning" type="warning" effect="plain" style="margin-left:10px;">
                        选中{{ progressVolume }}将自动把之前分册所有单词标记为已掌握
                    </el-tag>
                </div>
                <el-divider></el-divider>
                <div style="max-height:400px;overflow-y:auto;">
                    <div v-for="unit in progressTree" :key="unit.unitId" style="margin-bottom:12px;">
                        <div style="font-weight:bold;font-size:14px;padding:8px 0;background:#f5f7fa;border-radius:4px;padding-left:10px;">
                            {{ unit.unitName }}
                            <span style="font-weight:normal;color:#909399;font-size:12px;margin-left:8px;">
                                已掌握 {{ unit.masteredCount }}/{{ unit.words.length }}
                            </span>
                        </div>
                        <div style="display:flex;flex-wrap:wrap;padding:6px 0 0 16px;">
                            <div v-for="w in unit.words"
                                 :key="w.wordId"
                                 :class="['word-item', { 'word-mastered': w.masteryStatus >= 2 }]"
                                 :style="{
                                     padding: '4px 10px',
                                     margin: '3px',
                                     borderRadius: '4px',
                                     cursor: 'pointer',
                                     border: w._checked ? '2px solid #409EFF' : '2px solid transparent',
                                     background: w._checked ? '#ecf5ff' : (w.masteryStatus >= 2 ? '#f0f9eb' : '#fff'),
                                     color: w.masteryStatus >= 3 ? '#67c23a' : (w.masteryStatus >= 2 ? '#606266' : '#303133'),
                                     fontSize: '13px',
                                     position: 'relative'
                                 }"
                                 @click="onWordClick(unit, w)">
                                <span>{{ w.word }}</span>
                                <span style="color:#909399;font-size:11px;margin-left:4px;">{{ w.chineseMeaning }}</span>
                                <span v-if="w.masteryStatus >= 3" style="margin-left:4px;color:#67c23a;">★</span>
                                <span v-if="w.masteryStatus === 2" style="margin-left:4px;color:#67c23a;">✓</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top:12px;padding:8px 0;border-top:1px solid #ebeef5;">
                    <span style="color:#606266;">
                        已选：<strong style="color:#409EFF;">{{ progressSelectedCount }}</strong> 个单词将被标记为已掌握
                    </span>
                </div>
            </template>
            <div slot="footer">
                <el-button type="danger" @click="resetWordProgress" :disabled="progressLoading" icon="el-icon-delete">
                    重置单词进度
                </el-button>
                <el-button @click="progressDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitProgress" :disabled="progressSelectedCount === 0 || progressLoading">
                    确认保存
                </el-button>
            </div>
        </el-dialog>

        <!-- 试卷充值/扣减对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            :title="rechargeForm.addCount >= 0 ? '试卷充值' : '试卷扣减'"
            :visible.sync="rechargeDialogVisible"
            width="500px"
            class="student-dialog">
            <el-form :model="rechargeForm" ref="rechargeForm" :rules="rechargeRules" label-width="80px">
                <el-form-item label="学生姓名">
                    <el-input :value="currentStudent.nickname" disabled></el-input>
                </el-form-item>
                <el-form-item label="当前剩余">
                    <el-input :value="currentStudent.count || 0" disabled></el-input>
                </el-form-item>
                <el-form-item label="充值套数" prop="addCount">
                    <el-input-number v-model="rechargeForm.addCount" :min="-9999" :max="9999" style="width: 100%"></el-input-number>
                    <div style="color: #909399; font-size: 12px; margin-top: 5px;">正数表示充值，负数表示扣减</div>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="rechargeDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitRecharge">确认充值</el-button>
            </div>
        </el-dialog>

        <!-- 课时充值/扣减对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            :title="classHoursRechargeForm.addCount >= 0 ? '课时充值' : '课时扣减'"
            :visible.sync="classHoursRechargeDialogVisible"
            width="500px"
            class="student-dialog">
            <el-form :model="classHoursRechargeForm" ref="classHoursRechargeForm" :rules="classHoursRechargeRules" label-width="80px">
                <el-form-item label="学生姓名">
                    <el-input :value="currentStudent.nickname" disabled></el-input>
                </el-form-item>
                <el-form-item label="当前剩余">
                    <el-input :value="currentStudent.classHours || 0" disabled></el-input>
                </el-form-item>
                <el-form-item label="充值课时" prop="addCount">
                    <el-input-number v-model="classHoursRechargeForm.addCount" :min="-9999" :max="9999" style="width: 100%"></el-input-number>
                    <div style="color: #909399; font-size: 12px; margin-top: 5px;">正数表示充值，负数表示扣减</div>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="classHoursRechargeForm.remark" type="textarea" :rows="2" maxlength="200" show-word-limit placeholder="请输入充值/扣减原因"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="classHoursRechargeDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitClassHoursRecharge">确认充值</el-button>
            </div>
        </el-dialog>

        <!-- 家长信息抽屉 -->
        <parent-drawer ref="parentDrawer"></parent-drawer>
        <!-- 课时记录抽屉 -->
        <class-hours-log-drawer ref="classHoursLogDrawer"></class-hours-log-drawer>
    </div>
</template>

<script>
import {
    reqGetSysUsersById,
    reqListSysUsers,
    reqDeleteSysUsers,
    reqInsertSysUsers,
    reqUpdateSysUsers,
    reqUpdateUserType,
    reqRechargePaperCount,
    reqRechargeClassHours,
    reqImportStudents,
    reqStudentImportTemplate
} from '@/api/system/users'
import { reqClassPage } from '@/api/education/class'
import { reqGradeList } from '@/api/education/grade'
import { reqVolumeOptions } from '@/api/education/unit'
import { reqVolumeWords, reqMarkProgress, reqResetProgress } from '@/api/education/assessment'
import ParentDrawer from './components/ParentDrawer'
import ClassHoursLogDrawer from './components/ClassHoursLogDrawer'

export default {
    name: 'Student',
    components: { ParentDrawer, ClassHoursLogDrawer },
    data() {
        return {
            list: [],
            total: 0,
            gradeList: [],
            classList: [],
            filteredClassList: [],
            tableLoading: false,
            submitLoading: false,
            query: {
                roleMark: 'STUDENT',
                currentPage: 1,
                pageSize: 10,
                nickname: '',
                phone: '',
                studentNo: '',
                gradeId: null,
                classId: null,
                hasParent: null
            },
            dialogVisible: false,
            dialogTitle: '',
            importVisible: false,
            importLoading: false,
            importFile: null,
            importResult: null,
            formData: {
                roleMark: 'STUDENT',
                id: null,
                username: '',
                password: '123456',
                nickname: '',
                phone: '',
                gradeId: null,
                classId: null,
                studentNo: '',
                enrollmentDate: '',
                classHours: 0
            },
            rules: {
                gradeId: [
                    { required: true, message: '请选择所属年级', trigger: 'change' }
                ],
                classId: [
                    { required: true, message: '请选择所属班级', trigger: 'change' }
                ],
                studentNo: [
                    { required: true, message: '请输入学号', trigger: 'blur' }
                ],
                nickname: [
                    { required: true, message: '请输入学生姓名', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                username: [
                    { required: true, message: '请输入登录账号', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ]
            },
            typeDialogVisible: false,
            currentStudent: {},
            typeForm: { type: 1 },
            typeRules: {
                type: [{ required: true, message: '请选择学员类型', trigger: 'change' }]
            },
            progressDialogVisible: false,
            progressLoading: false,
            progressStudent: {},
            progressVolume: '',
            progressVolumeList: [],  // 当前学生的分册列表
            progressTree: [],
            progressReachedWordId: null,
            rechargeDialogVisible: false,
            rechargeForm: { addCount: 1 },
            rechargeRules: {
                addCount: [{ required: true, message: '请输入充值套数', trigger: 'blur' }]
            },
            classHoursRechargeDialogVisible: false,
            classHoursRechargeForm: { addCount: 0, remark: '' },
            classHoursRechargeRules: {
                addCount: [{ required: true, message: '请输入充值课时', trigger: 'blur' }],
                remark: [{ required: true, message: '请输入备注', trigger: 'blur' }]
            },
            currentOperateRow: null
        }
    },
    computed: {
        filteredQueryClassList() {
            if (!this.query.gradeId) return []
            return this.classList.filter(c => c.gradeId === this.query.gradeId)
        },
        showCascadeWarning() {
            if (!this.progressVolume || !this.progressVolumeList.length) return false
            return this.progressVolumeList.indexOf(this.progressVolume) > 0
        },
        progressSelectedCount() {
            let count = 0
            for (const unit of this.progressTree) {
                for (const w of unit.words) {
                    if (w._checked) count++
                }
            }
            return count
        }
    },
    created() {
        // 从 URL 参数读取搜索条件，自动填入并查询
        if (this.$route.query.nickname) {
            this.query.nickname = this.$route.query.nickname
        }
        this.loadGradeList()
        this.loadClassList()
        this.load()
    },
    methods: {
        handleOperateCommand(command) {
            const row = this.currentOperateRow
            if (!row) return
            switch (command) {
                case 'edit': this.btnInsert(row); break
                case 'changeType': this.btnChangeType(row); break
                case 'rechargePaper': this.btnRecharge(row); break
                case 'rechargeClassHours': this.btnRechargeClassHours(row); break
                case 'setProgress': this.btnSetProgress(row); break
                case 'delete': this.btnDelete(row.id); break
            }
        },
        showParentDrawer(row) {
            this.$refs.parentDrawer.handleView(row)
        },
        showClassHoursDrawer(row) {
            this.$refs.classHoursLogDrawer.handleView(row)
        },
        async loadGradeList() {
            try {
                this.gradeList = await reqGradeList()
            } catch (e) {
                console.error('加载年级列表失败:', e)
            }
        },
        async loadClassList() {
            try {
                const data = await reqClassPage({ currentPage: 1, pageSize: 100 })
                this.classList = data.records || []
            } catch (e) {
                console.error('加载班级列表失败:', e)
            }
        },
        onGradeChange() {
            this.formData.classId = null
            if (this.formData.gradeId) {
                this.filteredClassList = this.classList.filter(c => c.gradeId === this.formData.gradeId)
            } else {
                this.filteredClassList = []
            }
        },
        onFilterGradeChange() {
            this.query.classId = null
        },
        async load() {
            this.tableLoading = true
            try {
                const data = await reqListSysUsers(this.query)
                this.list = data.records || []
                this.total = data.total || 0
            } catch (e) {
                this.$message.error('加载学生列表失败')
                console.error(e)
            } finally {
                this.tableLoading = false
            }
        },
        handleSearch() {
            this.query.currentPage = 1
            this.load()
        },
        handleReset() {
            this.query = {
                roleMark: 'STUDENT',
                currentPage: 1,
                pageSize: 10,
                nickname: '',
                phone: '',
                studentNo: '',
                gradeId: null,
                classId: null,
                hasParent: null
            }
            this.load()
        },
        currentChange(num) {
            this.query.currentPage = num
            this.load()
        },
        sizeChange(size) {
            this.query.pageSize = size
            this.query.currentPage = 1
            this.load()
        },
        handlePhoneBlur() {
            if (this.formData.phone && !this.formData.id) {
                this.formData.username = this.formData.phone
            }
        },
        async btnInsert(row) {
            if (row) {
                this.dialogTitle = '编辑学生'
                try {
                    const data = await reqGetSysUsersById({ id: row.id })
                    this.formData = {
                        id: data.id,
                        gradeId: data.gradeId || null,
                        classId: data.classId || null,
                        studentNo: data.studentNo || '',
                        nickname: data.nickname || '',
                        phone: data.phone || '',
                        username: data.username || '',
                        password: '',
                        enrollmentDate: data.enrollmentDate || '',
                        classHours: data.classHours || 0
                    }
                    if (this.formData.gradeId) {
                        this.filteredClassList = this.classList.filter(c => c.gradeId === this.formData.gradeId)
                    }
                } catch (e) {
                    this.$message.error('获取学生信息失败')
                    return
                }
            } else {
                this.dialogTitle = '新增学生'
                this.formData = {
                    id: null,
                    gradeId: null,
                    classId: null,
                    studentNo: '',
                    nickname: '',
                    phone: '',
                    username: '',
                    password: '123456',
                    enrollmentDate: '',
                    classHours: 0
                }
                this.filteredClassList = []
            }
            this.$nextTick(() => {
                if (this.$refs.formData) {
                    this.$refs.formData.clearValidate()
                }
            })
            this.dialogVisible = true
        },
        closeDialog() {
            this.$refs.formData && this.$refs.formData.clearValidate()
        },
        closeImportDialog() {
            if (this.importLoading) return
            this.importFile = null
            this.importResult = null
            if (this.$refs.uploadRef) this.$refs.uploadRef.clearFiles()
        },
        downloadTemplate() {
            reqStudentImportTemplate().then(res => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = '学生导入模板.xlsx'
                a.click()
                window.URL.revokeObjectURL(url)
            }).catch(() => this.$message.error('模板下载失败'))
        },
        handleFileChange(file) {
            const isExcel = /\.(xlsx|xls)$/.test(file.name)
            if (!isExcel) {
                this.$message.error('仅支持 Excel 文件(.xlsx/.xls)')
                this.importFile = null
                if (this.$refs.uploadRef) this.$refs.uploadRef.clearFiles()
                return
            }
            this.importFile = file.raw || file
            this.importResult = null
        },
        async submitImport() {
            if (!this.importFile) {
                this.$message.warning('请先选择 Excel 文件')
                return
            }
            const formData = new FormData()
            formData.append('file', this.importFile)
            this.importLoading = true
            try {
                const res = await reqImportStudents(formData)
                // 响应拦截器成功时直接返回 data（即 { fail, total, failList, success }）
                if (res && typeof res.success !== 'undefined') {
                    this.importResult = res
                    if (this.importResult.fail === 0) {
                        this.$message.success('导入成功，共 ' + this.importResult.success + ' 条')
                        this.load()
                    } else {
                        this.$message.warning('导入完成：成功 ' + this.importResult.success + ' 条，失败 ' + this.importResult.fail + ' 条')
                        this.load()
                    }
                } else {
                    this.$message.error('导入失败')
                }
            } catch (e) {
                this.$message.error('导入异常：' + (e.message || e))
            } finally {
                this.importLoading = false
            }
        },
        async btnDelete(id) {
            try {
                await this.$confirm('确定要删除该学生吗？删除后不可恢复。', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                await reqDeleteSysUsers({ id })
                this.$message.success('删除成功')
                this.load()
            } catch (e) {
                if (e !== 'cancel') {
                    this.$message.error(e.message || '删除失败')
                }
            }
        },
        submitForm() {
            this.$refs.formData.validate(async valid => {
                if (!valid) return

                this.submitLoading = true
                try {
                    const submitData = { ...this.formData, roleMark: 'STUDENT' }
                    if (this.formData.id) {
                        await reqUpdateSysUsers(submitData)
                    } else {
                        submitData.password = submitData.password || '123456'
                        await reqInsertSysUsers(submitData)
                    }
                    this.$message.success('操作成功')
                    this.dialogVisible = false
                    this.load()
                } catch (e) {
                    this.$message.error(e.message || '操作失败')
                } finally {
                    this.submitLoading = false
                }
            })
        },
        btnChangeType(row) {
            this.currentStudent = row
            this.typeForm.type = row.type || 1
            this.typeDialogVisible = true
        },
        submitTypeChange() {
            this.$refs.typeForm.validate(async valid => {
                if (!valid) return
                this.submitLoading = true
                try {
                    await reqUpdateUserType({
                        id: this.currentStudent.id,
                        type: this.typeForm.type
                    })
                    this.$message.success('学员类型变更成功')
                    this.typeDialogVisible = false
                    this.load()
                } catch (e) {
                    this.$message.error(e.message || '操作失败')
                } finally {
                    this.submitLoading = false
                }
            })
        },
        async btnSetProgress(row) {
            this.progressStudent = row
            this.progressVolumeList = []
            this.progressVolume = ''
            this.progressTree = []
            this.progressReachedWordId = null
            this.progressDialogVisible = true
            // 加载该学生年级对应的分册选项
            if (row.gradeId) {
                try {
                    const res = await reqVolumeOptions(row.gradeId)
                    this.progressVolumeList = (res && Array.isArray(res)) ? res : ['上册', '下册']
                } catch (e) {
                    this.progressVolumeList = ['上册', '下册']
                }
            } else {
                this.progressVolumeList = ['上册', '下册']
            }
            // 默认选中第一个分册
            if (this.progressVolumeList.length > 0) {
                this.progressVolume = this.progressVolumeList[0]
                await this.loadVolumeWords()
            }
        },
        async onVolumeChange() {
            await this.loadVolumeWords()
        },
        async loadVolumeWords() {
            if (!this.progressStudent.gradeId) {
                this.$message.warning('该学生未设置年级')
                return
            }
            this.progressLoading = true
            try {
                const rawList = await reqVolumeWords(this.progressStudent.id, this.progressStudent.gradeId, this.progressVolume)
                const unitMap = {}
                for (const item of rawList) {
                    if (!unitMap[item.unitId]) {
                        unitMap[item.unitId] = {
                            unitId: item.unitId,
                            unitName: item.unitName,
                            unitNumber: item.unitNumber,
                            masteredCount: 0,
                            words: []
                        }
                    }
                    const word = {
                        wordId: item.wordId,
                        word: item.word,
                        chineseMeaning: item.chineseMeaning,
                        sort: item.sort,
                        masteryStatus: item.masteryStatus,
                        _checked: item.masteryStatus >= 2
                    }
                    unitMap[item.unitId].words.push(word)
                    if (item.masteryStatus >= 2) {
                        unitMap[item.unitId].masteredCount++
                    }
                }
                this.progressTree = Object.values(unitMap).sort((a, b) => a.unitNumber - b.unitNumber)
                this.syncCheckedState()
            } catch (e) {
                this.$message.error('加载单词数据失败')
            } finally {
                this.progressLoading = false
            }
        },
        syncCheckedState() {
            let foundUnchecked = false
            for (const unit of this.progressTree) {
                for (const w of unit.words) {
                    if (foundUnchecked) {
                        w._checked = false
                    } else if (!w._checked) {
                        foundUnchecked = true
                    }
                }
            }
        },
        onWordClick(unit, word) {
            const allWords = []
            for (const u of this.progressTree) {
                for (const w of u.words) {
                    allWords.push(w)
                }
            }
            const clickIdx = allWords.indexOf(word)
            if (word._checked) {
                const nextUnchecked = allWords.findIndex((w, i) => i > clickIdx && !w._checked)
                if (nextUnchecked === -1) {
                    for (let i = clickIdx; i < allWords.length; i++) {
                        allWords[i]._checked = false
                    }
                } else {
                    for (let i = 0; i <= clickIdx; i++) {
                        allWords[i]._checked = true
                    }
                    for (let i = clickIdx + 1; i < allWords.length; i++) {
                        allWords[i]._checked = false
                    }
                }
            } else {
                for (let i = 0; i <= clickIdx; i++) {
                    allWords[i]._checked = true
                }
                for (let i = clickIdx + 1; i < allWords.length; i++) {
                    allWords[i]._checked = false
                }
            }
            for (const u of this.progressTree) {
                u.masteredCount = u.words.filter(w => w._checked).length
            }
        },
        async submitProgress() {
            let lastCheckedWordId = null
            for (const u of this.progressTree) {
                for (const w of u.words) {
                    if (w._checked) lastCheckedWordId = w.wordId
                }
            }
            if (!lastCheckedWordId) {
                this.$message.warning('请至少选择一个单词')
                return
            }
            try {
                await this.$confirm('该操作不可逆，已掌握的单词将被重置为未学习状态，请认真检查后确认是否继续？', '确认操作', {
                    confirmButtonText: '确认保存',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                await reqMarkProgress({
                    studentUserId: this.progressStudent.id,
                    gradeId: this.progressStudent.gradeId,
                    volume: this.progressVolume,
                    reachedWordId: lastCheckedWordId
                })
                this.$message.success('学习进度设置成功')
                this.progressDialogVisible = false
            } catch (e) {
                if (e !== 'cancel') {
                    this.$message.error(e.message || '设置失败')
                }
            }
        },
        async resetWordProgress() {
            if (!this.progressStudent.id || !this.progressStudent.gradeId) {
                this.$message.warning('学生信息不完整')
                return
            }
            try {
                await this.$confirm('确定要重置该学生的所有单词学习进度吗？此操作将删除全部单词掌握记录，不可恢复！', '确认重置', {
                    confirmButtonText: '确认重置',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                this.progressLoading = true
                await reqResetProgress(this.progressStudent.id, this.progressStudent.gradeId)
                this.$message.success('单词进度已重置，请重新设置学习进度')
                // 重新加载单词列表
                await this.loadVolumeWords()
            } catch (e) {
                if (e !== 'cancel') {
                    this.$message.error(e.message || '重置失败')
                }
            } finally {
                this.progressLoading = false
            }
        },
        btnRecharge(row) {
            this.currentStudent = row
            this.rechargeForm.addCount = 0
            this.rechargeDialogVisible = true
        },
        submitRecharge() {
            this.$refs.rechargeForm.validate(async valid => {
                if (!valid) return
                if (this.rechargeForm.addCount === 0) {
                    this.$message.warning('充值数量不能为0')
                    return
                }
                try {
                    await reqRechargePaperCount({
                        id: this.currentStudent.id,
                        addCount: this.rechargeForm.addCount
                    })
                    if (this.rechargeForm.addCount > 0) {
                        this.$message.success(`成功充值 ${this.rechargeForm.addCount} 套试卷`)
                    } else {
                        this.$message.success(`成功扣减 ${Math.abs(this.rechargeForm.addCount)} 套试卷`)
                    }
                    this.rechargeDialogVisible = false
                    this.load()
                } catch (e) {
                    this.$message.error(e.message || '操作失败')
                }
            })
        },
        btnRechargeClassHours(row) {
            this.currentStudent = row
            this.classHoursRechargeForm.addCount = 0
            this.classHoursRechargeForm.remark = ''
            this.classHoursRechargeDialogVisible = true
        },
        submitClassHoursRecharge() {
            this.$refs.classHoursRechargeForm.validate(async valid => {
                if (!valid) return
                if (this.classHoursRechargeForm.addCount === 0) {
                    this.$message.warning('充值课时不能为0')
                    return
                }
                try {
                    await reqRechargeClassHours({
                        id: this.currentStudent.id,
                        addCount: this.classHoursRechargeForm.addCount,
                        remark: this.classHoursRechargeForm.remark
                    })
                    if (this.classHoursRechargeForm.addCount > 0) {
                        this.$message.success(`成功充值 ${this.classHoursRechargeForm.addCount} 课时`)
                    } else {
                        this.$message.success(`成功扣减 ${Math.abs(this.classHoursRechargeForm.addCount)} 课时`)
                    }
                    this.classHoursRechargeDialogVisible = false
                    this.load()
                } catch (e) {
                    this.$message.error(e.message || '操作失败')
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.student-page {
    padding: 0;

    .filter-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 16px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .table-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 14px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .card-header-left {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 15px;
            font-weight: 600;
            color: #303133;

            i {
                font-size: 18px;
                color: #409eff;
            }

            .header-sub {
                font-size: 13px;
                font-weight: 500;
                color: #909399;
            }

            .total-badge {
                font-size: 13px;
                font-weight: 400;
                color: #909399;
                margin-left: 8px;

                b {
                    color: #409eff;
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }

        .card-header-right {
            display: flex;
            align-items: center;
            gap: 10px;
        }
    }

    // ===== 弹窗自定义头部（与年级/班级一致）=====
    .batch-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .batch-header-left {
            display: flex;
            align-items: center;
            gap: 12px;
        }

        .batch-header-icon {
            width: 38px;
            height: 38px;
            border-radius: 10px;
            background: rgba(255, 255, 255, 0.22);
            display: flex;
            align-items: center;
            justify-content: center;

            i {
                font-size: 20px;
                color: #fff;
            }
        }

        .batch-header-title {
            font-size: 16px;
            font-weight: 600;
            color: #fff;
            line-height: 1.4;
        }

        .batch-header-desc {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.85);
            margin-top: 2px;
        }

        .batch-header-close {
            font-size: 18px;
            color: rgba(255, 255, 255, 0.85);
            cursor: pointer;
            transition: all 0.2s;

            &:hover {
                color: #fff;
                transform: rotate(90deg);
            }
        }
    }

    ::v-deep .student-dialog,
    ::v-deep .import-student-dialog {
        border-radius: 12px;

        .el-dialog__header {
            padding: 16px 22px;
            background: linear-gradient(135deg, #2e8b74 0%, #4fae93 100%);
            border-bottom: none;

            .el-dialog__title {
                color: #fff;
                font-size: 16px;
                font-weight: 600;
            }

            .el-dialog__headerbtn .el-dialog__close {
                color: rgba(255, 255, 255, 0.85);

                &:hover {
                    color: #fff;
                }
            }
        }

        ::v-deep .el-button--primary {
            background-color: #2e8b74;
            border-color: #2e8b74;

            &:hover, &:focus {
                background-color: #3aa98a;
                border-color: #3aa98a;
            }
        }
    }

    // ===== 导入弹窗内容 =====
    .import-body {
        .import-tip {
            margin-bottom: 18px;
        }

        .import-actions {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 12px;
        }

        .import-upload {
            display: inline-block;
        }

        .import-file {
            margin-top: 12px;
            font-size: 13px;
            color: #606266;
        }

        .import-result {
            margin-top: 6px;
            font-size: 14px;
            color: #303133;

            .ok {
                color: #2e8b74;
                font-size: 16px;
            }

            .fail {
                color: #f56c6c;
                font-size: 16px;
            }
        }

        .import-fail-list {
            margin-top: 10px;
            max-height: 180px;
            overflow-y: auto;
            background: #fafbfc;
            border: 1px solid #ebeef5;
            border-radius: 8px;
            padding: 8px 12px;

            .fail-title {
                font-size: 13px;
                font-weight: 600;
                color: #909399;
                margin-bottom: 6px;
            }

            .fail-item {
                font-size: 12px;
                color: #f56c6c;
                line-height: 1.8;
            }
        }
    }


    .filter-form {
        padding: 4px 0 0;

        ::v-deep .el-form-item {
            margin-bottom: 8px;
        }
    }

    .pagination-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }

    .action-dropdown-group {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 6px;
        white-space: nowrap;

        .el-button + .el-button {
            margin-left: 0;
        }
    }

    .class-hours-link {
        color: #409eff;
        cursor: pointer;
        font-weight: 600;
        padding: 2px 6px;
        border-radius: 4px;
        transition: all 0.2s;

        &:hover {
            background: #ecf5ff;
            color: #337ecc;
        }
    }

    .word-item:hover {
        background: #ecf5ff !important;
        border-color: #409eff !important;
    }

    .word-mastered {
        opacity: 0.7;
    }

    .danger-dropdown-item {
        color: #f56c6c !important;

        &:hover {
            background: #fef0f0 !important;
            color: #f56c6c !important;
        }
    }

    ::v-deep .el-divider--vertical {
        height: 1.2em;
        margin: 0 4px;
    }

    ::v-deep .el-table {
        th {
            background: #fafafa;
            color: #606266;
            font-weight: 600;
            font-size: 13px;
        }

        td {
            font-size: 13px;
        }

        .el-tag--plain {
            font-weight: 500;
        }
    }

    ::v-deep .el-dialog {
        border-radius: 6px;
        overflow: hidden;

        .el-dialog__header {
            padding: 16px 24px;
            border-bottom: 1px solid #ebeef5;

            .el-dialog__title {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }
        }

        .el-dialog__body {
            padding: 24px 30px 8px;
        }

        .el-dialog__footer {
            padding: 14px 30px;
            border-top: 1px solid #ebeef5;
        }
    }
}

@media screen and (max-width: 768px) {
    .student-page {
        .card-header {
            flex-wrap: wrap;
            gap: 8px;
        }

        .filter-form {
            ::v-deep .el-form--inline .el-form-item {
                display: block;
                width: 100%;
                margin-bottom: 12px;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content {
                width: 100%;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-select,
            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-input {
                width: 100% !important;
            }
        }

        ::v-deep .el-card__body {
            padding: 12px;
        }

        ::v-deep .el-table {
            overflow-x: auto;
            display: block;
        }

        ::v-deep .el-dialog {
            width: 95% !important;
            margin: 10px auto !important;
        }

        ::v-deep .el-dialog__body {
            padding: 16px;
        }

        ::v-deep .el-dialog__footer {
            padding: 12px 16px;
        }

        ::v-deep .el-pagination {
            white-space: normal;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 4px;
        }

        ::v-deep .el-pagination .el-pagination__total,
        ::v-deep .el-pagination .el-pagination__sizes {
            margin-right: 0;
        }

        ::v-deep .el-pagination button,
        ::v-deep .el-pagination .el-pager li {
            min-width: 28px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
        }
    }
}
</style>
